import { Injectable } from '@angular/core';
import {  HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { AuthenticationService } from './authentication.service';
import {ClientRequest} from  '../../ClientRequest';


@Injectable()
export class QuizSimulationService {
    constructor(private clientRequest: ClientRequest) {}

   /**********EXAM SIMULATOR***********/
   findExamSimulator(enroll_id, page): Observable<any> {
         return this.clientRequest.get('/simulator/exam/'+enroll_id+'?current_page='+page).map((response: HttpResponse<any>) => {
           return response;
        });
   }
   findSimulatorExamFullLengthTest(enroll_id): Observable<any> {
         return this.clientRequest.get('/simulator/exam/'+enroll_id+'/full').map((response: HttpResponse<any>) => {
           return response;
        });
   }
   findSimulatorExamFocusTest(enroll_id): Observable<any> {
         return this.clientRequest.get('/simulator/exam/'+enroll_id+'/focus').map((response: HttpResponse<any>) => {
           return response;
        });
   }
   startSimulatorExamFullLengthTest(quiz_id, enroll_id): Observable<any> {
         return this.clientRequest.post('/simulator/start/'+enroll_id+'/full?quiz_id='+quiz_id,{}).map((response: HttpResponse<any>) => {
           return response;
        });
   }
   startSimulatorExamFocusTest(quiz_id, enroll_id, model): Observable<any> {
        return this.clientRequest.post('/simulator/start/' + enroll_id +'/focus?quiz_id='+quiz_id, JSON.stringify(model)).map((response: HttpResponse<any>) => {
            return response;
        });
   }
   
   submitSimulatorExam(quiz_id,timeCountDown,answer,log_id, enroll_id, flags,attempt_id): Observable<any> {
        return this.clientRequest.post('/simulator/'+enroll_id+'/submit', JSON.stringify({ time: timeCountDown, answer: answer, flags: flags,log_id : log_id, quiz_id: quiz_id, attempt_id: attempt_id }))
            .map((response: HttpResponse<any>) => {
               return response;
            });
    }
    examSimulatorHistory(attempt_id): Observable<any> {
        return this.clientRequest.get('/simulation/'+attempt_id+'/history').map((response: HttpResponse<any>) => {
           return response;
        });
    };
    
    saveSimulatorExam(quiz_id,timeCountDown,answer,log_id, enroll_id, flags,attempt_id): Observable<any> {
        return this.clientRequest.post('/simulation/'+enroll_id+'/pause?quiz_id='+quiz_id, JSON.stringify({ time: timeCountDown, answer: answer,log_id : log_id , eid: enroll_id, flags: flags, attempt_id: attempt_id }))
            .map((response: HttpResponse<any>) => {
               return response;
            });
    }
}
